'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getAbsPath = undefined;

var _index = require('../constants/index');

var getAbsPath = exports.getAbsPath = function getAbsPath() {
  var pathname = arguments.length <= 0 || arguments[0] === undefined ? '' : arguments[0];
  var search = arguments.length <= 1 || arguments[1] === undefined ? '' : arguments[1];

  return _index.basePath + pathname + search;
};


/*****************
 ** WEBPACK FOOTER
 ** ./src/utils/url-transformer.js
 ** module id = 848
 ** module chunks = 0
 **/